import { api } from "./api";

// Lightweight engagement tracking. Fire-and-forget; never blocks the UI.
function getInvestor() {
  try {
    return JSON.parse(localStorage.getItem("s360_investor") || "null");
  } catch {
    return null;
  }
}

export function trackEvent(type, target, meta = null) {
  const inv = getInvestor();
  const payload = {
    type,
    target,
    meta,
    lead_id: null,
    email: inv?.email || null,
  };
  api.post("/events", payload).catch(() => {});
}

export const trackSectionView = (sectionId) => trackEvent("section_view", sectionId);
export const trackSectionDwell = (sectionId, dwellMs) => {
  if (!sectionId || !Number.isFinite(dwellMs) || dwellMs < 1500) return; // ignore tiny dwells
  trackEvent("section_dwell", sectionId, { dwell_ms: Math.round(dwellMs) });
};
export const trackCtaClick = (ctaKey, meta) => trackEvent("cta_click", ctaKey, meta);
